import styled from 'styled-components';
import Typography from '@hellodarwin/core/lib/components/common/typography';

export const DocumentSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  min-width: 0;
`;
export const DocumentList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;

  > li {
    width: 100%;
    min-width: 0;
  }
`;
export const DocumentRow = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding: ${({ theme }) => theme.spacing.md}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.border_radius.none};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-wrap: wrap;
  }
`;
export const DocumentDetails = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  overflow-wrap: anywhere;
`;
export const DocumentName = styled(Typography).attrs({ elementTheme: 'body2' })`
  margin: 0;
  font-weight: bold;
  overflow-wrap: anywhere;
`;
export const DocumentDownloadButton = styled.button`
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  max-width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: ${({ theme }) => theme.colors.transparent};
  color: ${({ theme }) => theme.colors.grey_1};
  cursor: pointer;
  font: inherit;
  text-align: left;

  &:hover > span:first-child,
  &:focus-visible > span:first-child {
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.purple_2};
    outline-offset: 2px;
  }

  > span:first-child {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  > span:last-child {
    display: inline-flex;
    flex-shrink: 0;
  }
`;
export const WorkingCard = styled.a`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding: ${({ theme }) => theme.spacing.md}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  color: inherit;
  text-decoration: none;
  overflow-wrap: anywhere;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-wrap: wrap;
  }
`;

export const WorkingDocumentIcon = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  color: ${({ theme }) => theme.colors.grey_2};
`;

export const WorkingDocumentDetails = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;

export const WorkingDocumentActions = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    margin-left: auto;
  }
`;

export const DocumentHeader = styled.header`
  padding-bottom: ${({ theme }) => theme.spacing.md}px;
  border-bottom: thin solid ${({ theme }) => theme.colors.grey_4};
`;
export const DocumentSubtitle = styled(Typography).attrs({
  elementTheme: 'body3',
})`
  color: ${({ theme }) => theme.colors.grey_2};
  margin: 0;
`;
export const DocumentGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  min-width: 0;
`;
export const RequiredDocumentList = styled(DocumentList)`
  gap: 0;

  > li {
    margin: 0;
  }

  > li + li {
    border-top: none;
  }
`;
export const DocumentIcon = styled.div<{ $bucket: boolean }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  fill: ${({ theme, $bucket }) =>
    $bucket ? theme.colors.purple_2 : theme.colors.grey_2};
`;
export const DocumentActions = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.md}px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    flex-shrink: 1;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const DocumentGroupTitle = styled(Typography).attrs({
  elementTheme: 'body2',
})`
  font-weight: bold;
  margin: 0;
`;
